import { getLanguageFromLocale } from '@/utils/translations/localizationHelpers';

import interpolate from '@/utils/translations/interpolate';

import { Language } from '@/utils/translations/types/TypeLanguagesAndLocales';

export type AgeUnit = 'weeks' | 'months' | undefined;

export default function formatProductAgeBand(
  ageUnit: AgeUnit,
  minAgeInput: number | undefined,
  maxAgeInput: number | undefined,
  locale: string | undefined,
) {
  if (
    typeof ageUnit == undefined ||
    typeof minAgeInput == undefined ||
    typeof maxAgeInput == undefined
  ) {
    console.warn('[formatProductAgeBand] Missing Required parameters');

    return '';
  }

  const minAge = minAgeInput as number;
  const maxAge = maxAgeInput as number;

  if (ageUnit === 'weeks') {
    return interpolate(_getWeeksLocalizedCopy(locale), { minAge, maxAge });
  }

  const isThreeMonthProduct = maxAge - minAge === 2;

  if (isThreeMonthProduct) {
    const [minMonth, midMonth, maxMonth] = _constructAgesArray(minAge, maxAge);

    return interpolate(_getThreeMonthRangeLocalizedCopy(locale), {
      minMonth,
      midMonth,
      maxMonth,
    });
  }

  return interpolate(_getMonthsLocalizedCopy(locale), { minAge, maxAge });
}

function _constructAgesArray(minAge: number, maxAge: number) {
  const ages = [];

  for (let i = minAge; i <= maxAge; i++) {
    ages.push(i);
  }

  return ages;
}

function _getMonthsLocalizedCopy(locale: string | undefined) {
  const language = getLanguageFromLocale(locale);
  switch (language) {
    case Language.English:
      return 'Months {{minAge}}-{{maxAge}}';
    case Language.French:
      return '{{minAge}}-{{maxAge}} mois';
    case Language.Dutch:
      return '{{minAge}}-{{maxAge}} maanden';
    case Language.Spanish:
      return 'Meses {{minAge}}-{{maxAge}}';
    case Language.German:
      return 'Monat {{minAge}}-{{maxAge}}';
    default:
      return 'missing translation';
  }
}

function _getWeeksLocalizedCopy(locale: string | undefined) {
  const language = getLanguageFromLocale(locale);

  switch (language) {
    case Language.English:
      return 'Weeks {{minAge}}-{{maxAge}}';
    case Language.French:
      return '{{minAge}}-{{maxAge}} semaines';
    case Language.Dutch:
      return '{{minAge}}-{{maxAge}} weken';
    case Language.Spanish:
      return 'Semanas {{minAge}}-{{maxAge}}';
    case Language.German:
      return 'Woche {{minAge}}-{{maxAge}}';
    default:
      return 'missing translation';
  }
}

function _getThreeMonthRangeLocalizedCopy(locale: string | undefined) {
  const language = getLanguageFromLocale(locale);

  switch (language) {
    case Language.English:
      return 'Months {{minMonth}}, {{midMonth}}, {{maxMonth}}';
    case Language.French:
      return '{{minMonth}}, {{midMonth}}, {{maxMonth}} mois';
    case Language.Dutch:
      return 'Maanden {{minMonth}}, {{midMonth}}, {{maxMonth}}';
    case Language.Spanish:
      return 'Meses {{minMonth}}, {{midMonth}}, {{maxMonth}}';
    case Language.German:
      return 'Monat {{minMonth}}, {{midMonth}}, {{maxMonth}}';
    default:
      return 'missing translation';
  }
}
